import { useEffect, useRef, useState } from 'react'
import { useInView, useMotionValue, animate } from 'motion/react'

export default ({ end, duration = 2, suffix = '' }) => {
  const nodeRef = useRef(null)
  const isInView = useInView(nodeRef, { once: true })
  const count = useMotionValue(0)
  const [displayValue, setDisplayValue] = useState(0)

  useEffect(() => {
    if (isInView) {
      const controls = animate(count, end, {
        duration,
        onUpdate: (latest) => {
          setDisplayValue(Math.round(latest))
        }
      })
      return controls.stop
    }
  }, [isInView, count, end, duration])

  return (
    <span ref={nodeRef}>
      {displayValue}
      {suffix}
    </span>
  )
}